// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loan-details {
  padding: 43px 40px;
  overflow: hidden;
}
.loan-details .loan-details-top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  border-bottom: 1px solid #929FB0;
  margin-bottom: 22px;
}
.loan-details .loan-details-top-bar .loan-info {
  margin-bottom: 2px;
}
.loan-details .loan-details-top-bar .loan-info .loan-borrower-name {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.24px;
  text-transform: uppercase;
}
.loan-details .loan-details-top-bar .loan-info .loan-address {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.24px;
  text-transform: uppercase;
}
.loan-details .loan-details-top-bar .close-button-container {
  cursor: pointer;
  color: var(--800-grey, #404859);
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.24px;
  text-transform: uppercase;
}
.loan-details .loan-details-first-row {
  display: flex;
  justify-content: space-between;
  border-bottom: solid 1px #CCD3DB;
  margin-bottom: 16px;
}
.loan-details .loan-details-first-row .loan-progress {
  flex: 6 1;
}
.loan-details .loan-details-first-row .loan-progress .loan-info .loan-status {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.36px;
}
.loan-details .loan-details-first-row .loan-progress .loan-info .loan-closing-date {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.36px;
}
.loan-details .loan-details-first-row .loan-progress .loan-info .loan-closing-date b {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.36px;
}
.loan-details .loan-details-first-row .loan-progress .loan-address {
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
}
.loan-details .loan-details-first-row .loan-progress .loan-progress-section {
  margin-bottom: 20px;
}
.loan-details .loan-details-first-row .loan-progress .loan-progress-section .loan-progress-items-container {
  display: flex;
  flex-direction: row;
}
.loan-details .loan-details-first-row .loan-progress .loan-progress-section .loan-progress-items-container > * {
  flex: 1 1;
  margin-right: 8px;
}
.loan-details .loan-details-first-row .loan-progress .loan-progress-section .loan-progress-items-container .loan-progress-item-caption {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  white-space: nowrap;
  margin-bottom: 6px;
  flex: 0.13 1;
}
.loan-details .loan-details-first-row .loan-progress .loan-values-summary {
  margin-bottom: 8px;
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
}
.loan-details .loan-details-first-row .loan-progress .loan-values-summary span {
  cursor: pointer;
  color: var(--blue60, #5E8EB7);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 115%;
}
.loan-details .loan-details-first-row .placeholder {
  flex: 3 1;
}
.loan-details .loan-details-first-row .borrower-card {
  flex: 1 1;
}
.loan-details .loan-details-main {
  display: flex;
}
.loan-details .loan-details-main > * {
  flex: 1 1;
  box-sizing: border-box;
}
.loan-details .loan-details-main .left-column {
  padding-right: 15px;
}
.loan-details .loan-details-main .left-column > * {
  margin-bottom: 16px;
}
.loan-details .loan-details-main .left-column > *:last-of-type {
  margin-bottom: 0px;
}
.loan-details .loan-details-main .left-column .loan-summary {
  display: flex;
  justify-content: space-between;
}
.loan-details .loan-details-main .left-column .loan-summary .closing {
  flex: 1 1;
  border-radius: 10px;
  border: 1px solid var(--500-grey, #AFBDCC);
  padding: 16px 20px;
  margin-right: 16px;
}
.loan-details .loan-details-main .left-column .loan-summary .closing .label {
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 18px;
}
.loan-details .loan-details-main .left-column .loan-summary .closing .calendar {
  width: 128px;
  border-radius: 10px;
  border: 1px solid var(--blue60, #5E8EB7);
  background: var(--10, #F5FAFF);
  margin-bottom: 8px;
}
.loan-details .loan-details-main .left-column .loan-summary .closing .calendar.disabled {
  border: 1px solid var(--600-grey, #929FB0);
  background: var(--200-grey, #EFF3F5);
}
.loan-details .loan-details-main .left-column .loan-summary .closing .calendar.disabled .date {
  color: var(--70, #48759A);
  border-bottom: 1px solid #929FB0;
}
.loan-details .loan-details-main .left-column .loan-summary .closing .calendar.disabled .day {
  color: var(--300-grey, #DFE4EB);
}
.loan-details .loan-details-main .left-column .loan-summary .closing .calendar .date {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 26px;
  border-bottom: 1px solid #5E8EB7;
  color: var(--70, #48759A);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 114.286% */
}
.loan-details .loan-details-main .left-column .loan-summary .closing .calendar .day {
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--blue-80, #355C7D);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.loan-details .loan-details-main .left-column .loan-summary .closing .caption {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}
.loan-details .loan-details-main .left-column .loan-summary .closing .caption b {
  font-weight: 600;
  color: #404859;
}
.loan-details .loan-details-main .left-column .loan-summary .content-box {
  flex: 5 1;
}
.loan-details .loan-details-main .right-column {
  padding-left: 15px;
}
.loan-details .loan-details-main .right-column .borrower-tasks > .title {
  margin-bottom: 8px;
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
}
.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-status-container {
  display: flex;
  margin-bottom: 16px;
}
.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 7px;
}
.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-actions > div {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  margin-left: 16px;
  color: var(--700-grey, #6E7889);
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.24px;
  text-transform: uppercase;
}
.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-actions > div svg {
  position: relative;
}
.loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-list {
  margin-bottom: 17px;
}
.loan-details .loan-details-main .right-column .action-button {
  border: 1px solid var(--100, #162E43);
  background: var(--100, #162E43);
  text-align: center;
  border-radius: 6px;
  padding: 14px 0px;
  margin-bottom: 30px;
  color: var(--10, #F5FAFF);
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.24px;
}
.loan-details .loan-details-main .right-column .action-button:hover {
  background-color: #EBF6FF !important;
  border-color: #EBF6FF !important;
  color: #355D7D !important;
}
.loan-details .loan-details-main .right-column .loan-documents > .title {
  margin-bottom: 8px;
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
}
.loan-details .loan-details-main .right-column .approve-loan {
  padding: 14px 0px;
  text-align: center;
  border-radius: 6px;
  border: 1px solid var(--300-grey, #DFE4EB);
  background: var(--300-grey, #DFE4EB);
  color: var(--600-grey, #929FB0);
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.24px;
}

.loan-progress-item .caption {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
  text-align: center;
  margin-bottom: 4px;
}
.loan-progress-item .loan-progress-bar {
  width: 100%;
  height: 6px;
  border-radius: 16px;
  background: var(--300-grey, #DFE4EB);
}

.content-box {
  border-radius: 10px;
  border: 1px solid var(--500-grey, #AFBDCC);
  padding: 16px 20px;
}
.content-box .label {
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 10px;
}
.content-box .content {
  border-left: 1px solid #97BCF0;
  padding: 2px 0px;
  padding-left: 12px;
}
.content-box .content .item {
  margin-bottom: 8px;
}
.content-box .content .item:last-of-type {
  margin-bottom: 0px;
}
.content-box .content .item-row {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.content-box .content .item-row .value i {
  color: var(--700-grey, #6E7889);
}
.content-box .content .item-row .value span {
  cursor: pointer;
  color: var(--blue60, #5E8EB7);
  text-align: right;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.content-box .content .item-row.extra {
  margin-top: 8px;
  padding-left: 16px;
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: normal;
}
.content-box .content .item-row.extra .value {
  color: var(--700-grey, #6E7889);
}`, "",{"version":3,"sources":["webpack://./src/scenes/Private/LoanList/LoanDetails/LoanDetails.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EAEA,gBAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,mBAAA;EACA,gCAAA;EACA,mBAAA;AADJ;AAGI;EACE,kBAAA;AADN;AAGM;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;EACA,yBAAA;AADR;AAIM;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AAFR;AAMI;EACE,eAAA;EAEA,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;EACA,yBAAA;AALN;AASE;EACE,aAAA;EACA,8BAAA;EAEA,gCAAA;EACA,mBAAA;AARJ;AAUI;EACE,SAAA;AARN;AAUQ;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AARV;AAWQ;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AATV;AAWU;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AATZ;AAcM;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAZR;AAeM;EACE,mBAAA;AAbR;AAeQ;EACE,aAAA;EACA,mBAAA;AAbV;AAeU;EACE,SAAA;EACA,iBAAA;AAbZ;AAgBU;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,mBAAA;EACA,kBAAA;EAEA,YAAA;AAhBZ;AAqBM;EACE,kBAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AApBR;AAsBQ;EACE,eAAA;EAEA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AArBV;AA2BI;EACE,SAAA;AAzBN;AA4BI;EACE,SAAA;AA1BN;AA8BE;EACE,aAAA;AA5BJ;AA8BI;EACE,SAAA;EACA,sBAAA;AA5BN;AA+BI;EACE,mBAAA;AA7BN;AA+BM;EACE,mBAAA;AA7BR;AA+BQ;EACE,kBAAA;AA7BV;AAiCM;EACE,aAAA;EACA,8BAAA;AA/BR;AAiCQ;EACE,SAAA;EAEA,mBAAA;EACA,0CAAA;EAEA,kBAAA;EAEA,kBAAA;AAlCV;AAoCU;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,mBAAA;AAnCZ;AAsCU;EACE,YAAA;EAEA,mBAAA;EACA,wCAAA;EACA,8BAAA;EAEA,kBAAA;AAtCZ;AAwCY;EACE,0CAAA;EACA,oCAAA;AAtCd;AAwCc;EACE,yBAAA;EACA,gCAAA;AAtChB;AAyCc;EACE,+BAAA;AAvChB;AA2CY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,iBAAA;EAEA,gCAAA;EAEA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;AA5Cd;AA+CY;EACE,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA/Cd;AAmDU;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;AAjDZ;AAmDY;EACE,gBAAA;EACA,cAAA;AAjDd;AAsDQ;EACE,SAAA;AApDV;AAyDI;EACE,kBAAA;AAvDN;AA0DQ;EACE,kBAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAzDV;AA4DQ;EACE,aAAA;EACA,mBAAA;AA1DV;AA6DQ;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AA3DV;AA6DU;EACE,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EAMA,iBAAA;EAEA,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AAlEZ;AAoDY;EACE,kBAAA;AAlDd;AAmEQ;EACE,mBAAA;AAjEV;AAqEM;EACE,qCAAA;EACA,+BAAA;EACA,kBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,mBAAA;EAEA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AArER;AAuEQ;EACE,oCAAA;EACA,gCAAA;EAEA,yBAAA;AAtEV;AA2EQ;EACE,kBAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA1EV;AAkFM;EACE,iBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,0CAAA;EACA,oCAAA;EAEA,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAlFR;;AAyFE;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,mBAAA;EACA,kBAAA;EAEA,kBAAA;AAxFJ;AA2FE;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,oCAAA;AAzFJ;;AA6FA;EACE,mBAAA;EACA,0CAAA;EAEA,kBAAA;AA3FF;AA6FE;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,mBAAA;AA5FJ;AA+FE;EACE,8BAAA;EACA,gBAAA;EACA,kBAAA;AA7FJ;AA+FI;EACE,kBAAA;AA7FN;AA+FM;EACE,kBAAA;AA7FR;AAiGI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;AAhGN;AAmGQ;EACE,+BAAA;AAjGV;AAoGQ;EACE,eAAA;EAEA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAnGV;AAuGM;EACE,eAAA;EACA,kBAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAtGR;AAwGQ;EACE,+BAAA;AAtGV","sourcesContent":[".loan-details {\n  padding: 43px 40px;\n\n  overflow: hidden;\n\n  .loan-details-top-bar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    padding-bottom: 8px;\n    border-bottom: 1px solid #929FB0;\n    margin-bottom: 22px;\n\n    .loan-info {\n      margin-bottom: 2px;\n      \n      .loan-borrower-name {\n        color: var(--800-grey, #404859);\n        font-family: Inter;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 16px; /* 133.333% */\n        letter-spacing: 0.24px;\n        text-transform: uppercase;\n      }\n\n      .loan-address {\n        color: var(--800-grey, #404859);\n        font-family: Inter;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 16px;\n        letter-spacing: 0.24px;\n        text-transform: uppercase;\n      }\n    }\n\n    .close-button-container {\n      cursor: pointer;\n\n      color: var(--800-grey, #404859);\n      text-align: right;\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 16px; /* 133.333% */\n      letter-spacing: 0.24px;\n      text-transform: uppercase;\n    }\n  }\n\n  .loan-details-first-row {\n    display: flex;\n    justify-content: space-between;\n\n    border-bottom: solid 1px #CCD3DB;\n    margin-bottom: 16px;\n\n    .loan-progress {\n      flex: 6;\n      .loan-info {\n        .loan-status {\n          color: var(--800-grey, #404859);\n          font-family: Inter;\n          font-size: 12px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 16px;\n          letter-spacing: 0.36px;\n        }\n\n        .loan-closing-date {\n          color: var(--800-grey, #404859);\n          font-family: Inter;\n          font-size: 12px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 16px;\n          letter-spacing: 0.36px;\n\n          b {\n            color: var(--800-grey, #404859);\n            font-family: Inter;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: 16px;\n            letter-spacing: 0.36px;\n          }\n        }\n      }\n\n      .loan-address {\n        color: var(--900-grey, #2A2F3C);\n        font-family: Inter;\n        font-size: 32px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 40px;\n      }\n\n      .loan-progress-section {\n        margin-bottom: 20px;\n\n        .loan-progress-items-container {\n          display: flex;\n          flex-direction: row;\n\n          >* {\n            flex: 1;\n            margin-right: 8px;\n          }\n\n          .loan-progress-item-caption {\n            color: var(--800-grey, #404859);\n            font-family: Inter;\n            font-size: 10px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: normal;\n\n            white-space: nowrap;\n            margin-bottom: 6px;\n\n            flex: 0.13;\n          }\n        }\n      }\n\n      .loan-values-summary {\n        margin-bottom: 8px;\n\n        color: var(--800-grey, #404859);\n        font-family: Inter;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 115%;\n\n        span {\n          cursor: pointer;\n\n          color: var(--blue60, #5E8EB7);\n          font-family: Inter;\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 115%;\n        }\n      }\n  \n    }\n\n    .placeholder {\n      flex: 3;\n    }\n\n    .borrower-card {\n      flex: 1;\n    }\n  }\n\n  .loan-details-main {\n    display: flex;\n\n    >* {\n      flex: 1;\n      box-sizing: border-box;\n    }\n\n    .left-column {\n      padding-right: 15px;\n\n      >* {\n        margin-bottom: 16px;\n\n        &:last-of-type {\n          margin-bottom: 0px;\n        }\n      }\n\n      .loan-summary {\n        display: flex;\n        justify-content: space-between;\n\n        .closing {\n          flex: 1;\n\n          border-radius: 10px;\n          border: 1px solid var(--500-grey, #AFBDCC);\n          \n          padding: 16px 20px;\n\n          margin-right: 16px;\n\n          .label {\n            color: var(--900-grey, #2A2F3C);\n            font-family: Inter;\n            font-size: 22px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: normal;\n\n            margin-bottom: 18px;\n          }\n\n          .calendar {\n            width: 128px;\n\n            border-radius: 10px;\n            border: 1px solid var(--blue60, #5E8EB7);\n            background: var(--10, #F5FAFF);\n\n            margin-bottom: 8px;\n\n            &.disabled {\n              border: 1px solid var(--600-grey, #929FB0);\n              background: var(--200-grey, #EFF3F5);\n\n              .date {\n                color: var(--70, #48759A);\n                border-bottom: 1px solid #929FB0;\n              }\n\n              .day {\n                color: var(--300-grey, #DFE4EB);\n              }\n            }\n\n            .date {\n              display: flex;\n              align-items: center;\n              justify-content: center;\n\n              padding: 6px 26px;\n\n              border-bottom: 1px solid #5E8EB7;\n\n              color: var(--70, #48759A);\n              font-family: Inter;\n              font-size: 14px;\n              font-style: normal;\n              font-weight: 600;\n              line-height: 16px; /* 114.286% */\n            }\n\n            .day {\n              height: 68px;\n\n              display: flex;\n              align-items: center;\n              justify-content: center;\n\n              color: var(--blue-80, #355C7D);\n              font-family: Inter;\n              font-size: 32px;\n              font-style: normal;\n              font-weight: 600;\n              line-height: normal;\n            }\n          }\n          \n          .caption {\n            color: var(--800-grey, #404859);\n            font-family: Inter;\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 18px; /* 128.571% */\n\n            b {\n              font-weight: 600;\n              color: #404859;\n            }\n          }\n        }\n\n        .content-box {\n          flex: 5;\n        }\n      }\n    }\n\n    .right-column {\n      padding-left: 15px;\n\n      .borrower-tasks {\n        >.title {\n          margin-bottom: 8px;\n\n          color: var(--900-grey, #2A2F3C);\n          font-family: Inter;\n          font-size: 32px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 40px;\n        }\n\n        .borrower-tasks-status-container {\n          display: flex;\n          margin-bottom: 16px;\n        }\n\n        .borrower-tasks-actions {\n          display: flex;\n          align-items: center;\n          justify-content: flex-end;\n          margin-bottom: 7px;\n\n          >div {\n            cursor: pointer;\n\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 3px;\n\n            svg {\n              position: relative;\n            }\n\n            margin-left: 16px;\n\n            color: var(--700-grey, #6E7889);\n            text-align: right;\n            font-family: Inter;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            letter-spacing: 0.24px;\n            text-transform: uppercase;\n          }\n        }\n\n        .borrower-tasks-list {\n          margin-bottom: 17px;\n        }\n      }\n\n      .action-button {\n        border: 1px solid var(--100, #162E43);\n        background: var(--100, #162E43);\n        text-align: center;\n\n        border-radius: 6px;\n        padding: 14px 0px;\n        margin-bottom: 30px;\n\n        color: var(--10, #F5FAFF);\n        text-align: center;\n        font-family: Inter;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        letter-spacing: 0.24px;\n\n        &:hover {\n          background-color: #EBF6FF !important;\n          border-color: #EBF6FF !important;\n    \n          color: #355D7D !important;\n        }\n      }\n\n      .loan-documents {\n        >.title {\n          margin-bottom: 8px;\n\n          color: var(--900-grey, #2A2F3C);\n          font-family: Inter;\n          font-size: 32px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 40px;\n        }\n\n        .loan-documents-list {\n          \n        }\n      }\n\n      .approve-loan {\n        padding: 14px 0px;\n        text-align: center;\n\n        border-radius: 6px;\n        border: 1px solid var(--300-grey, #DFE4EB);\n        background: var(--300-grey, #DFE4EB);\n\n        color: var(--600-grey, #929FB0);\n        text-align: center;\n        font-family: Inter;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        letter-spacing: 0.24px;\n      }\n    }\n  }\n}\n\n.loan-progress-item {\n  .caption {\n    color: var(--800-grey, #404859);\n    font-family: Inter;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n\n    white-space: nowrap;\n    text-align: center;\n\n    margin-bottom: 4px;\n  }\n\n  .loan-progress-bar {\n    width: 100%;\n    height: 6px;\n    border-radius: 16px;\n    background: var(--300-grey, #DFE4EB);\n  }\n}\n\n.content-box {\n  border-radius: 10px;\n  border: 1px solid var(--500-grey, #AFBDCC);\n\n  padding: 16px 20px;\n\n  .label {\n    color: var(--900-grey, #2A2F3C);\n    font-family: Inter;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n\n    margin-bottom: 10px;\n  }\n\n  .content {\n    border-left: 1px solid #97BCF0;\n    padding: 2px 0px;\n    padding-left: 12px;\n\n    .item {\n      margin-bottom: 8px;\n      \n      &:last-of-type {\n        margin-bottom: 0px;\n      }\n    }\n\n    .item-row {\n      color: var(--800-grey, #404859);\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    \n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      .value {\n        i {\n          color: var(--700-grey, #6E7889);\n        }\n\n        span {\n          cursor: pointer;\n          \n          color: var(--blue60, #5E8EB7);\n          text-align: right;\n          font-family: Inter;\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: normal;\n        }\n      }\n\n      &.extra {\n        margin-top: 8px;\n        padding-left: 16px;\n\n        color: var(--900-grey, #2A2F3C);\n        font-family: Inter;\n        font-size: 14px;\n        font-style: italic;\n        font-weight: 400;\n        line-height: normal;\n\n        .value {\n          color: var(--700-grey, #6E7889);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
